import { ReactComponent as TopLightSVG } from "./top-bg.svg"

export default TopLightSVG